import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const NewReply = ({
  onReply,
  parentId,
  setShowEditMessage,
  showEditMessage,
  versionKey
}) => {
  const [editCopy, setEditCopy] = useState('');
  const [postDisabled, setPostDisabled] = useState(true);

  const replyTextarea = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    onReply({ note: editCopy, parent_id: parentId, versionKey });
    setEditCopy('');
    setShowEditMessage(false);
  };

  useEffect(() => {
    if (editCopy) {
      setPostDisabled(false);
    } else {
      setPostDisabled(true);
    }
  }, [editCopy]);

  useEffect(() => {
    if (!showEditMessage) {
      setEditCopy('');
    }
  }, [showEditMessage]);

  useEffect(() => {
    if (showEditMessage) {
      replyTextarea.current.focus();
    }
  }, [showEditMessage]);

  return (
    <form
      className={`edit-message ${showEditMessage ? 'active' : ''}`}
      onSubmit={handleSubmit}
    >
      <div className="edit-message__header">
        <p>{t('Leave a reply')}</p>
        <button
          className="close-reply-button"
          onClick={() => setShowEditMessage((prevState) => (!prevState))}
          type="button"
        >
          <span className="bff-close" />
        </button>
      </div>
      <textarea
        ref={replyTextarea}
        className="edit-message__input bf-textarea"
        onChange={(e) => setEditCopy(e.target.value)}
        value={editCopy}
      />
      <button
        className="edit-message__button button primary sm"
        disabled={postDisabled}
        type="submit"
      >
        {t('Post')}
      </button>
    </form>
  );
};

NewReply.propTypes = {
  onReply: PropTypes.func.isRequired,
  versionKey: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  setShowEditMessage: PropTypes.func.isRequired,
  showEditMessage: PropTypes.bool.isRequired,
};

export default NewReply;
